<template>
  <row>
    <col :span="24">
    <i-button type="primary">
      <common-icon type="md-add" />{{$t('pages_combo_rule_list_290')}}</i-button>
    </col>
    <col :span="24">
    <i-table ref="table"
             :highlight-row="true"
             :columns="columns"
             :data="versions">
      <template slot="action"
                slot-scope="{ row }">
        <i-button type="primary"
                  @click="view(row)">{{$t('libs_table_render_71')}}</i-button>
      </template>
    </i-table>
    <Modal :width="1000"
           v-model="showDetail">
      <h3>{{$t('pages_products_op_history_index_864')}}</h3>
      <pre>
        {{ detail.object }}
      </pre>
      <h3>{{$t('pages_products_op_history_index_865')}}</h3>
      <pre>{{ detail.object_changes }}</pre>
    </Modal>
    </col>
  </row>
</template>

<script>
import i18n from '../../locales/index'

/* eslint-disable */
import CommonIcon from '_c/common-icon';
import { mapActions, mapState } from 'vuex';
export default {
  name: "Specs",
  components: {
    CommonIcon
  },
  data () {
    const self = this;
    return {
      showDetail: false,
      detail: {},
      columns: [
        {
          key: "id",
          title: "ID"
        },
        {
          key: 'item_type',
          title: i18n.t('pages_products_op_history_index_866'),
        },
        {
          key: 'item_id',
          title: i18n.t('pages_products_op_history_index_867'),
        },
        {
          key: 'event',
          title: i18n.t('pages_products_op_history_index_868'),
        },
        {
          key: 'username',
          title: i18n.t('pages_messages_index_619'),
        },
        {
          key: "id",
          title: i18n.t('pages_ai_image_163'),
          slot: 'action',
        }
      ],
    };
  },
  computed: {
    ...mapState('version', ['version', 'versions', 'meta', 'loading']),
  },
  methods: {
    ...mapActions('version', ['index']),
    view (data) {
      console.log(data);
      this.showDetail = true;
      this.detail = data;
    }
  },
  mounted () {
    this.index();
  }
};
</script>

<style lang="less">
.spec_handlers {
  > button {
    margin-right: 4px;
  }
}
</style>
